<!-- Please remove this disable statement when editing this file! -->
<!-- eslint-disable tailwindcss/no-custom-classname -->
<table [ngClass]="tableClass">
  <thead
    class="tw-text-bold tw-border-0 tw-border-b-2 tw-border-solid tw-border-secondary-300 tw-text-muted"
  >
    <ng-content select="[header]"></ng-content>
  </thead>
  <tbody>
    <ng-container
      *ngTemplateOutlet="templateVariable.template; context: { $implicit: rows }"
    ></ng-container>
  </tbody>
</table>
